import { PkMovementForm } from '../../components/PkMovementForm'
import * as S from './PkMovementPage.styles'

export const PkMovementPage: React.FC = () => (
  <S.Wrapper>
    <PkMovementForm />
  </S.Wrapper>
)
